<template>
	<div class="container">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>档案管理</el-breadcrumb-item>
			<el-breadcrumb-item>线损区域管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="搜索："  v-if="user.username == 'admin'">
				<el-select size="small" v-model="departmentId" @change="changeDept" placeholder="请选择部门">
				   <el-option v-for="item in departmentList"  :key="item.id" :value="item.id" :label="item.departmentName"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" @click="handleEdit()">添加</el-button>
        <!-- <el-button size="small" type="success"  @click="handleyt()">添加能源用途</el-button> -->
			</el-form-item>
		</el-form>



      <!-- 数据列表 -->
    <el-table size="small" row-key="id" :data="dataList"
       v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="this.$store.state.headerCss">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="areaName" label="区域名称">
         </el-table-column>
        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="setGs(scope.row)">设置</el-button>
            <el-button size="mini" type="warning"  @click="handelDetail(scope.row)" >编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteGs(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
			<!-- 新增新增区域对话框 -->
		<el-dialog  :title="title" :visible.sync="editNyuanFromVisible" width="30%" >
			<el-form label-width="100px"  >
        <el-form-item label="选择部门">
        	<el-select size="small" v-model="departmentId" v-if="user.username == 'admin'">
             <el-option v-for="item in departmentList" :key="item.id" :value="item.id" :label="item.departmentName"></el-option>
        	</el-select>

        </el-form-item>
				<el-form-item label="区域名称">
          <el-input size="small" v-model="areaName" ></el-input>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="editNyuanFromVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" :loading="saveLoad" @click="saveFx">确 定</el-button>
			</div>
		</el-dialog>





    <!-- 添加计量点界面 -->
    <el-dialog  title="新增计量点" :visible.sync="addFormVisible" width="50%"  @close="closeAdd">
    	<!-- <el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input> -->
      <el-form :inline="true">

        <el-form-item   >
          <el-input placeholder="请输入计量点名称" size="small"  v-model="meterForm.meterName"></el-input>
        </el-form-item>
        <el-form-item  >

          <el-select v-model="meterForm.terminalCode" placeholder="请选择用能单元" size="small" filterable >
              <el-option
                v-for="item in terminalData"
                :key="item.id"
                :label="item.terminalName"
                :value="item.terminalCode">
              </el-option>
            </el-select>

        </el-form-item>

        <el-form-item  >
          <el-button size="mini" type="primary"  :loading="loadMeter" @click="getBindMeters()">搜索</el-button>
        </el-form-item>

      </el-form>
    	<el-table size="small" :data="tables" height="500px"  @selection-change="getAddMeterIds" ref='bindTable'
    	 v-loading="loadMeter">
    		<el-table-column type="selection"></el-table-column>
        <el-table-column type="index" ></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
    		<el-table-column label="所属单元" prop="terminalName" width="200"></el-table-column>
        <el-table-column label="当前所属区域"  width="200">
          <template slot-scope="scope">
            <el-tag    size="mini" v-if="scope.row.areaName">{{scope.row.areaName}}</el-tag>
            <el-tag type="danger" size="mini" v-else>暂无</el-tag>
          </template>
        </el-table-column>


    	</el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='addFormVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="addMeters()">确认</el-button>
    	</div>
    </el-dialog>

    <!-- 设置计量点界面对话框 -->
    <el-dialog title="设置计量点" :visible.sync="editGs">

        <el-form :inline="true">

          <el-button size="small" type="primary" @click="showNoBindMters">添加</el-button>
          <el-button size="small" type="danger"  @click="delMeter"  :disabled="!choisData.length" >删除</el-button>
        </el-form>


        <p>当前区域已绑定的计量点</p>
    	  <el-table height="300" style="width: 100% ;margin-top: 10px;" size="small"
        :data="choisData" border v-loading="loadE" ref="tableMeter" @selection-change="setMeterChoise" >
    		  <el-table-column align="center" type="selection" width="50">
    		  </el-table-column>
          <el-table-column label="计量点id" prop="id" width="180"></el-table-column>
    		  <el-table-column label="计量点名称" prop="meterPointName" ></el-table-column>

    		  <el-table-column label="所属单元" prop="terminalName" ></el-table-column>

    	  </el-table>
        <!-- <p>数量:{{meterData.length}}</p> -->
    	  <div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="editGs = false">取 消</el-button>
    		<!-- <el-button size="mini" type="primary" @click="saveFormula(0)" :loading="saveLoad">确 定</el-button> -->
    	  </div>
    </el-dialog>



	</div>
</template>

<script>
  import {
    getDepartmentTerminalInfoLis,
    getEnergyTypeList,
    getTerminalInfoByDepId,
    saveOrUpdateArea,
    findAreaList,AreaDelete,
    getMeterInfoList,
    addAreaMeterInfo,
    removeAreaMeterInfo
    } from '../../api/energyMG'
  import { getNyfx,addFx,getGs,addFormula,delFormula,getMeterList,saveEnergyDataItem} from '../../api/analysisMG'

	export default {
		data() {
			return {
        areaName:"",
        addFormVisible:false,
        saveLoad:false,
        setLoading:false,
        loadMeter:false,
        searchDatas:"",
        visible:false,
				dataList: [],
        user:{},
        treeLoad:false,
        departmentId:"",
				typeList: [],
        choiseData:[],
        getJZ:"",
				loading: false,
        editGs:false,
				formInline: {},
				depLoading:false,
				jzProps: {
					children: 'deps',
				},
        yongTuForm:{
          energyName:""
        },
        meterForm:{
          areaId:'',
          meterName:"",
          terminalCode:"",
          energyType:"",
          depId:'',
        },
        areaId:"",
        aId:"",
        typePurpose:[],
				nyTitle:'新增',
				editNyuanFromVisible:false,
				energyData:[],
        departmentList:[],
        meterInfoListTemp:[],
				eneryType:"",
        fxIds:'',
        gs:'',
        choisData:[],
        editData:[],
        energyName:"",
        energyFx:"",
        loadE:false,
        meterIds:"",
        eid:"",
        treeLoad:false,
        getJZ:"",
        treeDate:[],
        meterData:[],
        MeterInfoList:[],
        department_id:"",
        energy_type:"",
        tempAddMeterList:[],
        tempDelMeterList:[],
        jzProps:{
        	label: function( data,node ){
        		//console.log(data)
        	},
        	children: 'deps',
        },
        title:"",
        energyFrom:{
          departmentId:"",
          energyType:"",
          terminalCode:"",
          isEnergyData:"",
          meterName:""
        },
        terminalData:[],
        showYongTu:false
			}
		},
    computed: {
    	tables() {
    		let search = this.searchDatas
    		if (search) {
    			return this.MeterInfoList.filter(data => {
    				return Object.keys(data).some(key => {
    					return String(data[key]).toLowerCase().indexOf(search) > -1
    				})
    			})
    		}
    		return this.MeterInfoList
    	}
    },
		created() {
			this.getJzData()

			this.$store.dispatch('getEnergyTypeConfig').then( (res) => {
				this.energyData = res
			})
     this.user = JSON.parse(sessionStorage.getItem('userdata'))



		},

		methods: {


      closeAdd(){
        this.meterForm.meterName = ""
        this.meterForm.terminalCode = ""
      },
      handleyt(){

        this.showYongTu= true
        this.yongTuForm.energyName = ''
      },


      getAddMeterIds(e){
        this.tempAddMeterList = e
      },
      delMeter(){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( res => {
          let Ids = this.tempDelMeterList.map(item => item).join('-')


          removeAreaMeterInfo({ meterIds:Ids }).then(res => {
            if(res.status == 1){
               this.meterForm.areaId = this.areaId
                this.getBindMeters()
              this.$message.success("操作成功")
            }else{
              this.$message.error(res.msg)
            }

          })
        })

      },



      saveYt(){
        saveEnergyDataItem(this.yongTuForm).then(res=>{
          if( res.status == 1){
            this.$message.success('操作成功')
            this.showYongTu = false
          }else{
             this.$message.error('操作失败')
          }
        })
      },


      // 设置计量点
      setGs(row){
        this.editGs = true


        this.departmentId = row.departmentId
        this.meterForm.areaId = row.id
        this.areaId = row.id
        this.meterForm.depId = row.departmentId
        this.getBindMeters()

        this.terminalData = this.departmentList.filter(item => item.id == this.departmentId)[0].terminalInfo

      },

      showNoBindMters(){
        this.addFormVisible = true
        this.meterForm.areaId = ''
        this.meterForm.meterName = ''
        this.meterForm.terminalCode = ''
        this.loadMeter = true
        this.getBindMeters();
      },

      addMeters(){

        this.saveLoad = true

        let param = {
          meterIds:this.tempAddMeterList.map(item => item.id).join('-'),
          areaId:this.areaId
        }
        addAreaMeterInfo(param).then(res => {
          this.saveLoad = false
          if(res.status == 1){
            this.addFormVisible = false
            this.$message.success('操作成功！')

            this.meterForm.areaId = this.areaId
            this.getBindMeters()
          }else{
             this.$message.error('操作失败')
          }
        })


      	this.$refs.bindTable.clearSelection();
      },


      saveFormula(isDelete){

      },


      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
              this.departmentList = res.data.menuDepList
              this.departmentId = this.departmentList[0].id
              this.getData()
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData( data ){
      	data.forEach(item =>{
      		if( item.terminalInfo){
      			if(!item.deps){
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz= true
      				item.deps.push(obj)
      			})
      		}
      		if( item.deps){
      			this.changeData(item.deps)
      		}
      	})

      	return  data
      },

      handleNodeClick(data) {
      	this.getJZ = data.departmentName
        this.energyFrom.terminalCode = data.terminalCode
        this.visible = false
      },




      changeDept(){
        if( this.user.username != 'admin'){
          this.departmentId = this.user.departmentId
        }
        let param = {
          departmentId:this.departmentId
        }

        this.getData()


      },
      getData(){
        this.loading = true
        findAreaList({depId:this.departmentId}).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
          }
        })
      },


			handleEdit(){
				this.editNyuanFromVisible = true
        this.areaName = ''
        this.aId = ''
        this.eneryType = ''
        this.fxIds = ''

        this.$nextTick(()=>{
           this.$refs.typeTble.clearSelection();
        })
        
        this.title = '添加'
			},

      handelDetail(row){
        this.title = '修改'
        this.editNyuanFromVisible = true
        this.areaName  = row.areaName
        this.aId = row.id
      },


      //保存
      saveFx(){


        if(this.areaName == ''){
          this.$message.info('请输入区域名称')
          return
        }
        this.saveLoad = true
        let param = {
          depId:this.departmentId,
          areaName:this.areaName,
          id:this.aId

        }
        saveOrUpdateArea(param).then(res => {
          this.saveLoad = false
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.getData()
            this.editNyuanFromVisible = false
          }else{
            this.$message.error(res.msg)
          }
        })
      },



      getBindMeters(){
        this.loadE = true
        getMeterInfoList(this.meterForm).then(res => {
          this.loadE = false
          this.loadMeter = false
          if( res.status == 1 ){
            if(this.meterForm.areaId != ''){
              this.choisData = res.data.data
            }

            this.MeterInfoList = res.data.data
          }
        })
      },


      //获取计量点
      getMeterList(){
        this.energyFrom.departmentId = this.department_id
        this.energyFrom.energyType = this.energy_type
        this.loadMeter = true

        getMeterList( this.energyFrom ).then( res => {
          this.loadMeter = false
          if(res.status == 1 ){
            this.MeterInfoList = res.data.dataList
          }

        })
      },


      setMeterChoise(e){

        this.tempDelMeterList = e.map(item => item.id)

        console.log(this.tempDelMeterList)
      },




      deleteGs(row){
        let param ={
          areaId:row.id
        }
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( ()=> {
          AreaDelete(param).then( res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getData()
            }
          })
        })

      }
		}
	}
</script>

<style scoped>
	.treel{
		padding: 0 20px;
		font-size: 13px;
	}
  .gs{
    height: 100px;
  }
	.treel i{
		font-size: 14px;
	}
	.treel /deep/ .el-tree-node{
		white-space: normal !important;
	}
	.treel /deep/ .el-tree-node__content{
		height: auto;
		padding: 6px 0;
	}

</style>



// WEBPACK FOOTER //
// src/views/archives/area.vue